export const convertDate = (str:string) => {
  let d = new Date(str);
  let day = d.getDate();
  let month = d.toString().split(" ")[1];
  let year = d.toString().split(" ")[3];
  return day + " " + month + `’` + year?.substring(year?.length - 2);
};
